import { Injectable, Pipe, PipeTransform } from "@angular/core";
import { NotificationType } from "../models/notification-type.enum";

@Pipe({
    name: "notificationTypeIconPipe"
})
export class NotificationTypeIconPipe implements PipeTransform {
    transform(notificationType: NotificationType): string {
        switch (notificationType) {
            case NotificationType.MAINTENANCE:
                return "ri-tools-line";
            case NotificationType.NEW_FEATURE:
                return "ri-star-line";
            case NotificationType.GENERAL:
                return "ri-notification-3-line";
            default:
                return "ri-notification-3-line";
        }
    }
}